class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this._savedScrollY = window.scrollY;
    this._scrollRestore = () => { if (window.scrollY !== this._savedScrollY) window.scrollTo(0, this._savedScrollY); };
    window.addEventListener('scroll', this._scrollRestore, { passive: false });

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this._scrollRestore) { window.removeEventListener('scroll', this._scrollRestore); this._scrollRestore = null; }
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* 
  SPドロワー内の入荷日フィルター非表示処理
*/
document.addEventListener('DOMContentLoaded', () => {
  // SPドロワー内の「入荷日」フィルターを探して非表示にする処理
  const hideArrivalFilter = () => {
    // ドロワー内のすべてのフィルター項目を取得します
    const mobileFilters = document.querySelectorAll('.mobile-facets__details');

    // 各フィルター項目をチェックします
    mobileFilters.forEach(filter => {
      // フィルターのタイトルが入っているspan要素を探します
      const titleSpan = filter.querySelector('.mobile-facets__summary span:first-child');
      
      // span要素があり、そのテキストが「入荷日」の場合
      if (titleSpan && titleSpan.textContent.trim() === '入荷日') {
        // そのフィルター全体（detailsタグ）を非表示にします
        filter.style.display = 'none';
      }
    });
  };

  // DOMContentLoadedで実行します。
  hideArrivalFilter();

  // 動的に追加される要素にも対応するため、MutationObserverを設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // 追加された要素が入荷日フィルターかチェック
            if (node.classList && node.classList.contains('mobile-facets__details')) {
              const titleSpan = node.querySelector('.mobile-facets__summary span:first-child');
              if (titleSpan && titleSpan.textContent.trim() === '入荷日') {
                node.style.display = 'none';
              }
            }
            // 子要素内にmobile-facets__detailsがある場合もチェック
            const mobileFilters = node.querySelectorAll && node.querySelectorAll('.mobile-facets__details');
            if (mobileFilters) {
              mobileFilters.forEach(filter => {
                const titleSpan = filter.querySelector('.mobile-facets__summary span:first-child');
                if (titleSpan && titleSpan.textContent.trim() === '入荷日') {
                  filter.style.display = 'none';
                }
              });
            }
          }
        });
      }
    });
  });

  // ドキュメント全体を監視
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});